<template>
  <div class="progress-container">
    <progress></progress>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
//Colors
$progress-bar-color: $colorBrand !default;
$progress-bar-background:#FFFFFF !default;

//Sizes
$progress-height: 6px !default;
$progress-width: 100% !default;

//Apparence
$progress-border-radius: 5px !default;


// PROGRESS STYLE
.progress-container {
	width:$progress-width;
	height:$progress-height;
	display:block;
	position:relative;

	progress {
		position: relative;
		height: $progress-height;
		display: block;
		width: 100%;
		color: $progress-bar-color;
		background-color: $progress-bar-background;
		border-radius: $progress-border-radius;
		background-clip: padding-box;
		overflow: hidden;
		margin:0; 

		&[value] {
			position: absolute;
			background-color: inherit;
			top: 0;
			bottom: 0;
			background-color: $progress-bar-color;
			transition: width 0.5s cubic-bezier(0, 0, 1, -0.12);
			-webkit-appearance: none;
			appearance: none;
		}		

		&[value]::-webkit-progress-bar  {
			background-color: $progress-bar-background;
		}

		&[value]::-webkit-progress-value {
			background-color: $progress-bar-color;
			transition: width 0.5s cubic-bezier(0, 0, 1, -0.12);
		}

    

		&:not([value]) {
			background-color: $progress-bar-color;

			&:before {
        content: '';
        position: absolute;
        background-color: inherit;
        top: 0;
        left:0;
        bottom: 0;
        will-change: left, right;
        animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;

			}
			&:after {
        content: '';
        position: absolute;
        background-color: inherit;
        top: 0;
        left:0;
        bottom: 0;
        will-change: left, right;
        animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
        animation-delay: 1.15s;
			}
		}
	}
  progress {
    // -webkit-appearance: none;
  }

  ::-webkit-progress-bar {
    background-color: $progress-bar-background;
  }
}

@keyframes indeterminate {
  0% {
    left: -35%;
    right:100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
}

@keyframes indeterminate-short {
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
}

</style>